import * as React from 'react'
import { Box, Typography, Tab, Tabs } from '@mui/material'
import { useState } from 'react'
import { ActivAffiliateds } from './ActiveAffiliateds'
import { PendingAffiliateds } from './PendingAffiliateds'
import { BlockedAffiliateds } from './BlockedAffiliateds'
import { a11yProps, TabPanel } from '../../components/Tabs'

export const AffiliatedsPage = () => {
  const [tabIndex, setTabIndex] = useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue)
  }

  return (
    <Box>
      <Typography variant="h5" fontWeight={500} sx={{ mb: 2 }}>
        Meus Afiliados
      </Typography>

      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            aria-label="affiliated tabs"
          >
            <Tab label="Ativos" {...a11yProps(0)} />
            <Tab label="Solicitações pendentes" {...a11yProps(1)} />
            <Tab
              label="Recusados, bloqueados ou cancelados"
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>
        <TabPanel value={tabIndex} index={0} sx={{ py: 3 }}>
          <ActivAffiliateds />
        </TabPanel>
        <TabPanel value={tabIndex} index={1} sx={{ py: 3 }}>
          <PendingAffiliateds />
        </TabPanel>
        <TabPanel value={tabIndex} index={2} sx={{ py: 3 }}>
          <BlockedAffiliateds />
        </TabPanel>
      </Box>
    </Box>
  )
}
